<template>
  <div class="account-connector-title">
    <div class="account-connector-title__name">{{ name }}</div>
    <div v-if="type" class="account-connector-title__type">{{ type }}</div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  name: string
  ticker?: string
  type?: string
}
defineProps<Props>()
</script>

<style>
.account-connector-title {
  @apply flex flex-col;
  @apply gap-y-1;

  &__name {
    @apply sm:text-xl;
    @apply leading-none;
    @apply text-gray-500;
    @apply line-clamp-3;
  }

  &__type {
    @apply text-sm sm:text-xs leading-none;
    @apply text-gray-400;
  }
}
</style>
